import React from "react";
import Analytics from "../../../helpers/analytics";
import { useHistory } from "react-router-dom";

const Logo = () => {
  const history = useHistory();

  return (
    <div className="jukin-logo">
      <a
        onClick={() => {
          localStorage.removeItem("prevPath");
          Analytics.track("JM_logo", {
            category: "LP-TopNav"
          });
          history.push("/licensing");
        }}
        className="logo"
      >
        <img style={{ height: "50px", width: "50px" }} src="https://i.imgur.com/QMVRNv4.png"></img>
      </a>
    </div>
  );
};

export default Logo;
